module.exports = __webpack_public_path__ + "img/hospital_2.61d453ab.png";